import React from 'react';
import { Form } from "@progress/kendo-react-form";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { DateInput } from "@progress/kendo-react-dateinputs";
import { Modal } from 'bootstrap';
import HfKendoComboBox from "../shared/HfKendoComboBox";
import Api from '../../services/api/api';

export default class PatientInfoPanel extends React.Component {

    constructor(props) {
        super(props);

        this.defaultManualPatient = {
            firstName: '',
            lastName: '',
            name: '',
            displayName: '',
            patientId: null,
            dateOfBirth: null,
            balance: 0,
            badDebt: 0
        };

        this.state = {
            manualPatient: this.defaultManualPatient,
            formKey: 0
        };

        this.addPatientModal = null;
        this.addPatientModalRef = React.createRef();
        this.addPatientModalFirstNameFieldRef = React.createRef();

        this.defaultProvider = props.provider;
        this.defaultInsurance = props.insurance;
        this.defaultLocation = props.location;
    }

    componentDidMount() {
        this.addPatientModal = Modal.getOrCreateInstance(this.addPatientModalRef.current);
        this.addPatientModalRef.current.addEventListener('shown.bs.modal', (e) => {
            this.addPatientModalFirstNameFieldRef.current.focus();
        });
        this.addPatientModalRef.current.addEventListener('hidden.bs.modal', (e) => {
            const patient = { ...this.defaultManualPatient };
            this.setState({
                manualPatient: patient,
                formKey: this.state.formKey + 1
            });
        });
    }

    handlePatientChange = (e) => {
        if (e.value !== null) {
            this.props.onPatientChange(e.value);
        } else {
            this.props.onPatientChange(null);
        }
    }

    handleProviderChange = (e) => {
        if (e.value !== null) {
            this.props.onProviderChange(e.value);
        } else {
            this.props.onProviderChange(null);
        }
    }

    handleInsuranceChange = (e) => {
        if (e.value !== null) {
            this.props.onInsuranceChange(e.value);
            if (!e.value.isBound && !e.value.isSelfPay) {
                //var span = document.getElementById('InsMessage');
                document.getElementById('InsMessage').innerHTML = '<div class="alert alert-danger" role="alert"><i class="bi bi-shield-fill-exclamation"></i> Note: Selected insurance is not bound to a schedule.</div>';
            } else {
                document.getElementById('InsMessage').innerHTML = '';
            }
        } else {
            this.props.onInsuranceChange(null);
            document.getElementById('InsMessage').innerHTML = '';
        }
    }

    handleLocationChange = (e) => {
        if (e.value !== null) {
            this.props.onLocationChange(e.value);
        } else {
            this.props.onLocationChange(null);
        }
    }

    showAddPatientModal = () => {
        this.addPatientModal.show();
    }

    hideAddPatientModal = (e) => {
        this.addPatientModal.hide();
    }

    handleManualPatientFirstNameChange = (e) => {
        const patient = { ...this.state.manualPatient, firstName: e.target.value };
        patient.name = this.formatName(patient);
        patient.displayName = this.formatDisplayName(patient);

        this.setState({
            manualPatient: patient
        });

    }

    handleManualPatientLastNameChange = (e) => {
        const patient = { ...this.state.manualPatient, lastName: e.target.value };
        patient.name = this.formatName(patient);
        patient.displayName = this.formatDisplayName(patient);

        this.setState({
            manualPatient: patient
        });
    }

    handleManualPatientIdChange = (e) => {
        const patient = { ...this.state.manualPatient, patientId: e.target.value };

        this.setState({
            manualPatient: patient
        });
    }

    handleManualPatientDateOfBirthChange = (e) => {
        const patient = { ...this.state.manualPatient, dateOfBirth: e.value };
        patient.name = this.formatName(patient);
        patient.displayName = this.formatDisplayName(patient);

        this.setState({
            manualPatient: patient
        });
    }

    handlePatientAdd = (e) => {
        this.props.onPatientAdd(this.state.manualPatient);

        this.hideAddPatientModal(e);
    }

    formatName(patient) {
        const firstName = patient.firstName;
        const lastName = patient.lastName;

        return `${lastName}, ${firstName}`;
    }

    formatDisplayName(patient) {
        const firstName = patient.firstName;
        const lastName = patient.lastName;
        const dateOfBirth = patient.dateOfBirth && patient.dateOfBirth.toLocaleDateString();

        return `${lastName}, ${firstName} - ${dateOfBirth}`;
    }

    manualPatientIsValid() {
        const hasName = Boolean(this.state.manualPatient.displayName);
        const hasId = Boolean(this.state.manualPatient.patientId);
        const hasDob = Boolean(this.state.manualPatient.dateOfBirth);

        return hasName && hasId && hasDob;
    }

    render() {
        return (
            <div id={this.props.id} className="card shadow">
                <div className="card-body">
                    <h5 className="card-title">Customer Information</h5>
                    <div className="row">
                        <div className="col-sm-2">
                            <label className="form-label">Customer Name</label>
                        </div>
                        <div className="col-sm-8">
                            <HfKendoComboBox
                                delay={500}
                                minLengthForSearch={4}
                                api={Api.searchPatients}
                                dataItemKey="patientId"
                                textField="displayName"
                                value={this.props.patient}
                                onChange={this.handlePatientChange}
                                placeholder="Search by Name or Patient/Enterprise ID..."
                                style={{ width: "100%" }}
                            />
                        </div>
                        <div className="col-sm-2">
                            <button type="button" className="btn btn-primary" onClick={this.showAddPatientModal}>Add Patient</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-2">
                            <label className="form-label">Patient ID</label>
                        </div>
                        <div className="col-sm-5">
                            <input type="text" className="form-control" readOnly value={this.props.patient ? this.props.patient.patientId : ''} />
                        </div>
                        <div className="col-sm-1">
                            <label className="form-label">Provider</label>
                        </div>
                        <div className="col-sm-4">
                            <HfKendoComboBox
                                loadOnInit={true}
                                api={Api.getProviders}
                                dataItemKey="name"
                                textField="name"
                                value={this.props.provider}
                                onChange={this.handleProviderChange}
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-2">
                            <label className="form-label">Insurance</label>                            
                        </div>
                        <div className="col-sm-5">
                            <HfKendoComboBox
                                loadOnInit={true}
                                api={Api.getInsurances}
                                dataItemKey="name"
                                textField="name"
                                value={this.props.insurance}
                                onChange={this.handleInsuranceChange}
                                style={{ width: "100%" }}
                            />
                            <span id="InsMessage"></span>
                        </div>
                        <div className="col-sm-1">
                            <label className="form-label">Location</label>
                        </div>
                        <div className="col-sm-4">
                            <HfKendoComboBox
                                loadOnInit={true}
                                api={Api.getLocations}
                                dataItemKey="name"
                                textField="name"
                                value={this.props.location}
                                onChange={this.handleLocationChange}
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                </div>
                <div className="modal fade" ref={this.addPatientModalRef} tabIndex="-1" role="dialog" aria-labelledby="Add Patient Modal">
                    <Form
                        key={this.state.formKey}
                        render={(formRenderProps) => (
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Add Patient</h5>
                                        <button type="button" className="btn-close" onClick={this.hideAddPatientModal} aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <div className="col-sm-10 col-sm-offset-1">
                                                If you can't find a patient using the search feature, you may manually enter the information below.
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label col-sm-3">First Name</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="50"
                                                    onChange={this.handleManualPatientFirstNameChange}
                                                    ref={this.addPatientModalFirstNameFieldRef}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label col-sm-3">Last Name</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    maxLength="50"
                                                    onChange={this.handleManualPatientLastNameChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label col-sm-3">Patient ID</label>
                                            <div className="col-sm-9">
                                                {/*ref={this.addPatientModalPatientIdFieldRef}*/}
                                                <NumericTextBox
                                                    spinners={false}
                                                    min={0}
                                                    maxLength={15}
                                                    format="#"
                                                    onChange={this.handleManualPatientIdChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label col-sm-3">Date Of Birth</label>
                                            <div className="col-sm-9">
                                                {/*ref={this.addPatientModalDateOfBirthFieldRef}*/}
                                                <DateInput
                                                    format="MM/dd/yyyy"
                                                    formatPlaceholder={{ year: "YYYY", month: "MM", day: "DD" }}
                                                    max={new Date()}
                                                    onChange={this.handleManualPatientDateOfBirthChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={this.hideAddPatientModal}>Close</button>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={!this.manualPatientIsValid()}
                                            onClick={this.handlePatientAdd}
                                        >Accept</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
        );
    }
}